import { DataService, ApiService, UserService } from "../service"

export class ProdHtService{

    static async getHtUserToken() {
        // const res = await DataService.get(`${ApiService.EngineerApi}/user/getHtUserToken`); // 老接口
        const res = await DataService.get(`${ApiService.EngineerApi}/user/getHtToken`); // 新接口
        console.log(res, '----')
        return res.data;
    }
  
    /**
     * 华天获取sw转中间格式的信息
     * @param prodId 
     * @param skuId 
     * @param Htoken 
     * @param fileName 
     * @param skuName 
     *  @param getHTToken 获取华天鉴权的回调函数
     * @returns 
     */
    static async download(StepFileServerPath: string,fileName:string,skuName:string, getHTToken:any) {
        let Htoken = await this.getHtUserToken();
        if(!Htoken) {
            const newToken = await getHTToken();
            if(!newToken) {
                return;
            }
            Htoken = newToken;
        }
        const res = await DataService.get(`${ApiService.JrzzApi}/${StepFileServerPath}?Htoken=${Htoken}&fileName=${encodeURIComponent(fileName)}&skuName=${encodeURIComponent(skuName)}`);
        res.Htoken = Htoken;
        return res;
    }

    // @param getHTToken 获取华天鉴权的回调函数
    static async filedownload(fileName:string,dataId:string, getHTToken:any) {
        let Htoken = await this.getHtUserToken();
        if(!Htoken) {
            const newToken = await getHTToken();
            if(!newToken) {
                return;
            }
            Htoken = newToken;
        }
        const res = await DataService.get(`${ApiService.JrzzApi}/prodHt/file/265/download?Htoken=${Htoken}&fileName=${encodeURIComponent(fileName)}&dataId=${dataId}`);
        res.Htoken = Htoken;
        return res;
    }

    // m模型预览
     static async filePreview(data:any) {
        const { prodId, fileName, dataId,skuId,categoryId} = data;
        const res = await DataService.get(`${ApiService.JrzzApi}/prodView/download/${prodId}/${skuId}?fileName=${encodeURIComponent(fileName)}&dataId=${dataId}&categoryId=${categoryId}`);
        return res;
    }

}